import {TimelineMax, Sine} from 'gsap';
const Shortcuts = require('../utils/Shortcuts');

function IntroTextP3(refDuration) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;

        const tl = new TimelineMax({
            paused: true
        });

        tl.set('[data-text-unit="introP3"]', {opacity: 0, yPercent: 20}, 'st');
        tl.to('[data-text-unit="introP3"]', refDuration * 0.15, {opacity: 1, yPercent: 0, ease: Sine.easeInOut}, 'st');
        tl.to('[data-text-unit="introP3"]', refDuration * 0.12, {opacity: 0, yPercent: -20, ease: Sine.easeInOut}, 'st+=' + refDuration * 0.5);

        constructor.timeline = tl;
        _created = true;
        return tl;
    };

    constructor.destroy = () => {
        if (!_created) return;
        Shortcuts.destroyTimeline(constructor);
        _created = false;
    };

    constructor.startDuration = refDuration * 0.15;
    constructor.totalDuration = refDuration;

    return constructor;
}

module.exports = IntroTextP3;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/texts/IntroTextP3.js